// activityEssenceReward
export default {
  routerTitle: '【盈寶證券】百萬獎金激勵創作者計劃',

  cardOneModuleTitle: '每月瓜分獎金池',
  cardOneContentTitle: '精華內容獎勵',
  cardOneAwardTitle: '每月獎金池總額',

  cardTwoModuleTitle: '季度排行榜獎勵',

  cardThreeModuleTitle: '活動時間',
  activityTime: '2023年5月1日開始',
  cardThreeSubTitle: '內容要求',
  cardThreeSubDesc1: '創作者發布財報解讀、文章、評論符合評選標準，可以被評選為精華，評選標準：',
  cardThreeSubDesc2: '創作者的內容被評為精華內容，可以獲得精華積分，規則如下：',
  cardThreeTable1Header1: '內容類別',
  cardThreeTable1Header2: '內容評選標準',
  cardThreeTable1Row11: '精華財報解讀',
  cardThreeTable1Row12:
    '1、結合港美個股最新發布的財報數據，進行深度的財報解讀分析；<br/>2、文章有價值投資或短線交易結論觀點；<br/>3、原創內容，內容客觀、邏輯清晰，圖文並茂，時效性強；<br/>4、財報發布後超過24小時或解讀內容不夠深度則評選為精華文章類型；<br/>5、單個創作者每天發文多篇，則根據文章數量及內容質量擇優評審。',
  cardThreeTable1Row21: '精華文章',
  cardThreeTable1Row22:
    '1、主題與港美股市場、新股、窩輪牛熊、港美ETF相關；<br/>2、原創內容，內容客觀，邏輯清晰，內容具備一定時效性；<br/>3、文章有價值投資或短線交易結論觀點則獲得精華概率更高；<br/>4、單個創作者每天發文多篇，則根據文章數量及內容質量擇優評審。',
  cardThreeTable1Row31: '精華話題',
  cardThreeTable1Row32:
    '1.有熱點時效，有討論價值性；<br/>2.作為話題主持人能維護話題氛圍，話題的內容和評論數量多，質量高。',
  cardThreeTable1Row41: '精華評論',
  cardThreeTable1Row42: '1、原創評論內容，與文章內容匹配度高，有個人觀點；<br/>2、精華評論為抽選方式，單個用戶每天最多獲得不超過3條精華。',
  cardThreeTable1Tips: '注：用戶多次積極發表原創文章、原創評論，雖未達精華標準，但內容具有參考價值觀點，將會根據發表數量及質量選取文章或評論給與精華文章或精華評論獎勵作為鼓勵。',

  cardThreeTable2Header1: '內容類別',
  cardThreeTable2Header2: '積分獎勵',
  cardThreeTable2Row1: '精華財報解讀/篇',
  cardThreeTable2Row2: '精華文章/篇',
  cardThreeTable2Row3: '精華話題/個',
  cardThreeTable2Row4: '精華評論/條',

  cardFourModuleTitle: '活動獎勵',
  cardFourSubTitle1: '1、精華內容獎勵',
  cardFourSubDesc1:
    '（1）每月獎池80000港元<br />（2）創作者獎勵=月獎池金額/社區當月總精華積分*創作者個人當月精華積分<br />（3）舉例：當月社區所有創作者累積獲得精華積分為2000，創作者A個人當月獲得精華積分為50，那麼該創作者收益=80000港元/2000*50=2000港元',
  cardFourSubTitle2: '2、排行榜獎勵',
  cardFourSubDesc2: '季度排行榜獎勵，按創作者當季度累積獲得的精華總積分排名',
  cardFourModuleTips: '注：用戶可在【我的-社區收益】了解個人精華內容獎勵情況及申請獎金提現',
  cardFourTableHeader1: '季度名次',
  cardFourTableHeader2: '獎勵金額',

  cardFiveModuleTitle: '常見問題',
  cardFiveModuleQ1: '社區L0等級用戶沒有發文權限,如何獲得發文權限及參與活動?',
  cardFiveModuleA1:
    'L0用戶可參與精華評論的評選獎勵，其餘獎勵項目須升級為L1等級獲得發文權限後才可參與,用戶通過在社區閱讀、評論、收藏、分享文章等方式獲得積分進行升級，具體規則可在【我的-社區權益】了解。',
  cardFiveModuleQ2: '其他平台財經自媒體創作者,是否可申請加入參與?',
  cardFiveModuleA2:
    '財經自媒體創作者可提供自媒體賬戶及文章鏈接等方式向社區運營專員申請開通發文權限直接參與活動，盈寶社區專員微信號:<a href="javascript:;" class="copy-link-txt" data-clipboard-action="copy" data-clipboard-text="winbull8">winbull8</a>',
  cardFiveModuleQ3: '社區積分收益獎勵與本精華內容獎勵有什麼不同?兩個獎勵可同時享受嗎?',
  cardFiveModuleA3:
    '1)社區積分收益是所有盈寶用戶每天在社區發文、點贊、評論等互動都會獲得積分，系統每天統計用戶積分貢獻比例並派發獎金，用戶可在【我的-社區收益】查詢及提現。<br/>2)用戶發布的文章或評論達到精華內容標準要求則可獲得精華積分，系統每月1號按獎勵規則統計及派發獎金，用戶可在【我的-社區收益】查詢及提現。<br/>3)用戶可同時獲得積分收益獎勵及精華內容獎勵，兩者可同享。',
  cardFiveModuleQ4: '排行榜獎勵什麼時間派發?',
  cardFiveModuleA4:
    '每個季度的第1天將會統計上個季度的精華排行榜名單並派發排行榜獎金，用戶可在【我的-社區收益】查看獎金併申請提現。',
  cardFiveModuleQ5: '除了在APP發布文章,是否支持在電腦發布文章?',
  cardFiveModuleA5:
    '社區L1等級用戶可以通過網址<a href="javascript:;" class="copy-link-txt" data-clipboard-action="copy" data-clipboard-text="https://admin.winbull8.com/h5/analyst/index.html">https://admin.winbull8.com/h5/analyst/index.html</a>登陸個人盈寶賬號發布文章。',
  cardFiveModuleQ6: '季度排行榜在什麼情況下，排名20以內沒有獎勵?',
  cardFiveModuleA6:
    '如季度排行榜前20名出現有積分排名相同的情況，那麼即使在排行榜顯示排名20以內的用戶，實際可能是20名以外。比如：你的精華積分是50分，榜單排名是第19名，但前面51分有3個用戶，榜單排名都是第18名，實際上他們是第18、19和20名，所以你是第21名，因此無法獲得排行榜獎勵。',
  cardFiveModuleQ7: '季度排行榜獎勵金額在什麼情況下可能和規則不一樣?',
  cardFiveModuleA7:
    '如季度排行榜出現積分排名相同的用戶，則需要均攤獎金，這種情況下相同排名的用戶獎金可能與規則不一致。例如：你和另外兩位用戶的積分都為50分，榜單排名同是第9名，但實際上三人是第9、10和11名，名次的獎金分別為500、500和200港元，但由於你們的積分一樣，為了公平，每人獲得的獎勵數是400港元，計算公式為（500+500+200）/3=400。'
}
